import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { getAgreementAtom } from 'api/agreements/getAgreementById';
import { BackButton } from 'components/Button';
import Divider from 'components/Divider/Divider';
import Spinner from 'components/Spinner/Spinner';
import { LargeHeader } from 'components/Text';
import { AGREEMENTS } from 'routes/overview/paths';
import { isAgreementStatusEditable } from 'utils/agreements/isAgreementInactive';
import checkLoadable from 'utils/recoil/checkLoadable';
import AgreementAddress from '../AgreementAddress/AgreementAddress';
import ChangeAgreementName from '../ChangeAgreementName/ChangeAgreementName';
export default function EditAgreement() {
  const [openBilling, setOpenBilling] = useState(false);
  const [openShipping, setOpenShipping] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    agreementId
  } = useParams();
  const agreement = useRecoilValueLoadable(getAgreementAtom(agreementId));
  const {
    contents,
    loading
  } = checkLoadable(agreement);
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  if (!contents?.id || !isAgreementStatusEditable(contents?.status)) {
    push(AGREEMENTS);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackButton, {
    to: AGREEMENTS
  }, /*#__PURE__*/React.createElement(LargeHeader, null, t('agreements.agreement'), " ", contents?.name)), /*#__PURE__*/React.createElement(ChangeAgreementName, null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(AgreementAddress, {
    open: openBilling,
    onClose: () => setOpenBilling(false),
    address: contents?.billingAddress
  }), /*#__PURE__*/React.createElement(AgreementAddress, {
    shipping: true,
    open: openShipping,
    onClose: () => setOpenShipping(false),
    address: contents?.shippingAddress
  }));
}